import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';
import { map, sortBy, flow } from 'lodash/fp';

export class TicketsService extends InjectableClass {
  constructor(Tickets, ticketReaderFactory, $q) {
    'ngInject';
    super({ Tickets, ticketReaderFactory, $q });

    this.ticketDataService = Tickets;
    this.tickets = {};
  }

  createOrUpdate(data, ticketId, force, silent, stashedPersonNumber) {
    return this.ticketDataService.createOrUpdate(
      data,
      ticketId,
      force,
      silent,
      stashedPersonNumber,
    );
  }

  changeBranchId(data, ticketId) {
    return this.ticketDataService.changeBranchId(data, ticketId);
  }

  downloadPreviewOfAccountswitchDatesProtocol(data) {
    return this.ticketDataService.downloadPreviewOfAccountswitchDatesProtocol(
      data,
    );
  }

  downloadPaymentPartnerOverviewDocument(id, data) {
    return this.ticketDataService.downloadPaymentPartnerOverviewDocument(
      id,
      data,
    );
  }

  filterTickets(ticketType, searchFilter, product) {
    return this.ticketDataService
      .filter(ticketType, searchFilter, product)
      .then((result) => {
        const { data, page, totalCounts } = result;
        return {
          data: flow(
            map((ticket) => this.ticketReaderFactory.createFor(ticket)),
            sortBy((ticket) => [ticket.created, ticket.desc], false),
          )(data),
          page,
          totalCounts,
        };
      });
  }

  getStateName(index, states) {
    return states[index];
  }

  getStateIndex(state, states) {
    if (angular.isNumber(state)) {
      return state;
    }
    let index = _.indexOf(states, state);
    if (index === -1) {
      throw new Error(`Unknown state given: ${state}`);
    }
    return index;
  }

  /**
   * Returns the next state from the given state.
   * The given state can be either the name or the index of a state.
   *
   * @param state {Number|String} The given states index or name
   * @return {String} The name of the state next to the given state
   */
  nextState(state, states, defaultState = null) {
    let stateIndex = this.getStateIndex(state);
    let nextStateIndex = stateIndex + 1;
    if (nextStateIndex < states.length) {
      return states[nextStateIndex];
    }
    return defaultState;
  }

  /**
   * Returns the previous state from the given state.
   * The given state can be either the name or the index of a state.
   *
   * @param state {Number|String} The given states index or name
   * @return {String} The name of the state previous to the given states
   */
  prevState(state, states, defaultState = null) {
    let currentIndex = this.getStateIndex(state);
    let prevStateIndex = currentIndex - 1;
    if (prevStateIndex > -1) {
      return states[prevStateIndex];
    }
    return defaultState;
  }

  downloadCsvConfig() {
    return this.ticketDataService.downloadCsvConfig();
  }
}
